<template>
  <dy-item-wrap :item="item">
    <yjp-input-number-range v-bind="$attrs" v-on="$listeners" :precision="item.precision || 0" />
  </dy-item-wrap>
</template>

<script>
import DyFormMixin from "../dyformitemMixin";
export default {
  mixins: [DyFormMixin]
};
</script>




// WEBPACK FOOTER //
// NumberRangeWidget.vue?11924302